import { MouseEvent, useState } from 'react';

import { Button } from '@mui/material';

import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import useIsMultipleTeamsEnabled from '@/hooks/useIsMultipleTeamsEnabled';

import TeamName from '../TeamName';
import { useSelectedTeamId, useTeam, useTeams } from '../hooks';
import ManagePopover from './ManagePopover';

function TeamMenu() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMultipleTeamsEnabled = useIsMultipleTeamsEnabled();
  const { teams, loading: teamsLoading } = useTeams(!isMultipleTeamsEnabled);
  const { selectedTeamId, loading, setTeamId } = useSelectedTeamId();

  const { team, loading: teamLoading } = useTeam(selectedTeamId);

  const isLoading = loading || teamLoading || teamsLoading;

  function openManagePopover(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function closeManagePopover() {
    setAnchorEl(null);
  }

  return (
    <>
      <Button
        variant="text"
        color="primary"
        onClick={openManagePopover}
        endIcon={<ChevronDownIcon color="secondary" />}
        sx={{ p: 0.5, userSelect: 'auto', height: 32, gap: 1 }}
        data-cy="team-name"
        disabled={isLoading}
      >
        <TeamName name={team?.name} icon={team?.icon} maxWidth={127} loading={!team} />
      </Button>
      {selectedTeamId && (
        <ManagePopover
          anchorEl={anchorEl}
          teams={teams}
          selectedTeamId={selectedTeamId}
          onClose={closeManagePopover}
          onSelectTeam={setTeamId}
          isMultipleTeamsEnabled={isMultipleTeamsEnabled}
        />
      )}
    </>
  );
}

export default TeamMenu;
